<template>
  <section class="sign-in-pages">
    <AuthStage v-if="onStageRoute" ref="stage" :busy="busy" :intro="introAllowed">
      <transition name="auth-card" mode="out-in">
        <router-view />
      </transition>
    </AuthStage>
    <router-view v-else />
  </section>
</template>

<script>
import AuthStage from '@/components/auth/AuthStage';
import AuthSvc from '@/services/AuthSvc';
import { introPlayed, shouldPlayIntro } from '@/util/auth/authIntro';

const STAGE_ROUTES = ['Login', 'ForgotPassword', 'UpdatePassword'];

export default {
  name: 'UnauthorizedLayout',
  components: { AuthStage },
  provide() {
    return {
      authStage: { pulse: (tone) => this.$refs.stage && this.$refs.stage.pulse(tone) },
    };
  },
  data() {
    return {
      busy: true,
      introAllowed: false,
    };
  },
  computed: {
    onStageRoute() { return STAGE_ROUTES.indexOf(this.$route.name) !== -1; },
  },
  async mounted() {
    if (!this.onStageRoute) {
      // Export gak kebagian panggung, jadi gak ada yang melepas kelas boot-nya
      document.documentElement.classList.remove('is-auth-boot');
      this.busy = false;
      return;
    }
    const status = await this.getUserStatus();
    if (status?.username) {
      // veil masih nutup; busy sengaja dibiarin biar intronya gak sempat mulai
      await this.$router.push({ name: 'CompanyActiveSelection' });
      return;
    }
    this.introAllowed = shouldPlayIntro({
      routeName: this.$route.name,
      hasSession: false,
      alreadyPlayed: introPlayed(),
      reduceMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    });
    this.busy = false;
  },
  methods: {
    // jaringan mati dihitung sebagai "gak ada sesi", formnya tetap tampil
    async getUserStatus() {
      try {
        const response = await AuthSvc.getUserStatus();
        return response.data;
      } catch (error) {
        return null;
      }
    },
  },
};
</script>
